import React, { useContext, useState } from "react";
import Logo from "../../../Resources/Logo/LogoBordered.png"
import STC from "../../../STCLibrary/STCFactory/STCFactory";
import ApiResponseHandler from "../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import { useNavigate, useParams } from "react-router-dom";
import NotificationContext from "../../../STCLibrary/NotificationSystem/NotificationContext";
import Login from "../Login/Login";
import { LoginAPIs } from "../../../API/LoginAPIs/LoginAPIs";

export default function ResetPassword() {

    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    
    const [matchingPasswords, setMatchingPasswords] = useState(true);

    const [showErrMsg, setShowErrMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const validatePassword = (value, confirmed) => {

        if(value !== confirmed){
            setErrorMsg(`Passwords do not match.`);
            return false;
        }

        if (value.length < 12) {
            setErrorMsg(`Password must be at least ${12} characters long.`);
            return false;
        }
        if (!/[A-Za-z]/.test(value)) {
            setErrorMsg("Password must contain at least one letter.");
            return false;
        }

        if (!/[0-9]/.test(value)) {
            setErrorMsg("Password must contain at least one number.");
            return false;
        }

        return true;

    }

    const handleSubmit = (e) => {
        e.preventDefault(e);
        e.stopPropagation(e);

        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        setShowErrMsg(false);
        setErrorMsg('');
        setMatchingPasswords(true);


        const postJSON = {
            "newPassword": password,
	        "passwordConfirm": confirmPassword
        }
        if(validatePassword(password, confirmPassword)){
            LoginAPIs.PostPasswordReset(routeParams.resetToken, postJSON)
            .then((response) => {
                setSending(false);
                if(response.status === 200 && !response.error){
                    setSuccess(true);
                    ApiResponseHandler(response, notificationCtx, navigate);
                }
                else{
                    setSending(false);
                }
            })
            .catch((err) => {
                // console.log(err);
                // setSending(false);
                // ApiResponseHandler(err.response, notificationCtx, navigate);
                if(err.response.status === 400){
                    console.log('here',err)
                    setErrorMsg(err.response.data.error);
                    setShowErrMsg(true);
                }
                else{
                    setErrorMsg('There was an error sending your password reset request. Please try again later.')
                    ApiResponseHandler(err.response, notificationCtx, navigate)
                }
            })
            .finally(() => {
                setSending(false);
            })
        }
        
        else{
            setMatchingPasswords(false);
            setSending(false);
        }

    }
  
  
    return (
        <div className="login-container">
            <div className="coloured-box-container">
                <div className='coloured-box'></div>
            </div>


            <div className='login-form-container'>
                
                <div className='login-form-card'>
                <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                <img src={Logo} alt="LogoBordered" className="LogoBordered" />
                </div>

                {routeParams.resetToken != '0' && 
                <div style={{textAlign: 'center'}}>
                    <strong>Create new password</strong>
                </div>}

                {routeParams.resetToken == '0' ?
                    <STC.Alert variant='warning'>
                        <div className='m-1'>We are sorry, this reset password link is invalid.</div>
                        <div className='m-1'>If you are a group leader and have received this link:</div>
                        <ul>
                            <li>It is likely that the email address we have on file is already linked to a <strong>Passenger Account</strong></li>
                            <li>The same email address cannot be used for a <strong>Passenger Account</strong> and a <strong>Leader Account</strong> </li>
                            <li>You will need to contact your sales representative and provide an alternative email address to be used to create your new <strong>Leader Account</strong></li>
                        </ul>
                        <div className='m-1'>We apologise for any inconvenience caused.</div>
                    </STC.Alert>
                
                :(success ? 
                
                <div className="m-2">
                    <div className='mt-2'>
                        <STC.Alert variant='success'>
                            Password successfully reset! Please log in with your new password to access your account.
                        </STC.Alert>
                    </div>
                    <div className="mt-2 text-center">
                        <span
                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                            onClick={()=> navigate('/')}
                        >
                            Return to Login
                        </span>
                    </div>
                </div>
                :
                <div className="m-2">
                    <STC.Form onSubmit={handleSubmit}>

                        <STC.Form.FloatingLabel className="mb-3">
                            <STC.Form.Control
                                id="floatingInputPassword"
                                value={password}
                                type="password"
                                disabled={sending}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                required
                                // isInvalid={!matchingPasswords}
                            />
                            <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputPassword">New Password</label>
                        </STC.Form.FloatingLabel>

                        <STC.Form.FloatingLabel>
                            <STC.Form.Control
                                id="floatingInputPasswordConf"
                                value={confirmPassword}
                                type="password"
                                disabled={sending}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm Password"
                                required
                                // isInvalid={!matchingPasswords}
                            />
                            <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputPasswordConf">Confirm New Password</label>
                        </STC.Form.FloatingLabel>


                        {(!matchingPasswords || showErrMsg) && <STC.Alert className='mt-2' variant='danger'>{errorMsg}</STC.Alert> }

                        <div className="mt-2" align={'right'}>
                            <STC.Button size='sm' disabled={sending} className={'cmn-button login-button'} type={'submit'}>{sending ? 'Submitting' : 'Submit'}</STC.Button>
                        </div>
                    </STC.Form>
                </div>
                )}
                </div>
            </div>
        </div>
    );
}

